import { PrimaryButton } from "@mnk/frontend/components/ui/button/PrimaryButton";

interface Props {
  setIsNewFolderModalOpen: (isOpen: boolean) => void;
  setIsNewProjectModalOpen: (isOpen: boolean) => void;
}

export const NoItems = ({ setIsNewFolderModalOpen, setIsNewProjectModalOpen }: Props) => {
  return (
    <div className="flex flex-col items-center justify-center w-full bg-white rounded-lg p-4 h-96 gap-8">
      <p className="text-gray-500">
        このフォルダには、まだアイテムがありません。
        <br />
        下記より新しいアイテムを作成してください。
      </p>
      <div className="flex items-center justify-center gap-2">
        <PrimaryButton className="text-xs" type="button" onClick={() => setIsNewProjectModalOpen(true)}>
          プロジェクト作成
        </PrimaryButton>
        <PrimaryButton className="text-xs" type="button" onClick={() => setIsNewFolderModalOpen(true)}>
          フォルダ作成
        </PrimaryButton>
      </div>
    </div>
  );
};
